import React, { FC, forwardRef, HTMLProps, useImperativeHandle } from 'react';

type ListUnvirtualizedProps<T> = {
  itemContent: (index: number, row: T) => void;
  rowCount: number;
  data: T[];
} & HTMLProps<HTMLDivElement>;

type Ref = {
  recomputeRowHeights: () => void;
};

export const ListUnvirtualized = forwardRef<Ref, ListUnvirtualizedProps<unknown>>(
  (props: ListUnvirtualizedProps<unknown>, ref) => {
    useImperativeHandle(
      ref,
      () => ({
        recomputeRowHeights: () => {},
      }),
      [],
    );

    const { itemContent, rowCount, data, className, style } = props;

    return (
      <div className={className} style={style}>
        {data.map((row, index) => itemContent(index, row))}
      </div>
    );
  },
);
